import { SvgCommonProperties } from '../../common/svg.interfaces';

export default function ClockSvg(props: SvgCommonProperties){
  return <svg
    height={props.height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="w-6 h-6"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="6" x2="12" y2="12" />
    <line x1="12" y1="12" x2="16" y2="14" />
  </svg>

}